const search = document.querySelector('.javtec-search');

if (search) {
  const input = search.querySelector('[ref="searchInput"]');
  const results = search.querySelector('[ref="predictiveSearchResults"]');
  const submit = search.querySelector('.javtec-search__submit');

  const openSearch = () => {
    search.classList.add('javtec-search--active');
  };

  const closeSearch = () => {
    search.classList.remove('javtec-search--active');

    if (input instanceof HTMLInputElement) {
      input.setAttribute('aria-expanded', 'false');
    }
  };

  input?.addEventListener('focus', openSearch);
  input?.addEventListener('click', openSearch);
  input?.addEventListener('input', openSearch);
  submit?.addEventListener('click', openSearch);

  search.addEventListener('focusout', (event) => {
    if (event.relatedTarget instanceof Node && search.contains(event.relatedTarget)) return;
    window.setTimeout(() => {
      if (document.activeElement instanceof Node && search.contains(document.activeElement)) return;
      closeSearch();
    }, 0);
  });

  search.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeSearch();
    }
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Node) || search.contains(event.target)) return;

    if (input instanceof HTMLInputElement && input.value.length === 0 && results instanceof HTMLElement) {
      results.replaceChildren();
    }

    closeSearch();
  });

  closeSearch();
}
